/**
 * Certification Service
 * Register Angular Services for all things Certification
 *
 * @package:  Betta
 * @version:  2.0
 * @author:   Cyrill N KALITA
 * @return Resource
 */

angular.module('flsServices').factory('Certification', ['$resource', function($resource){
    return $resource('/api/v2/certification/:id');
}]);
